module.exports = __webpack_public_path__ + "img/login_bg.74254110.png";